// PLAN-cockpit-v2-domain-lenses Phase 1: core / domain / tools グループ divider
import { Fragment } from 'react'
import { useV2Router, type LensId } from '../router'

const LABELS: Record<LensId, string> = {
  home: 'Home',
  reflect: 'Reflect',
  explore: 'Explore',
  judgment: 'Judgment',
  finance: 'Finance',
  health: 'Health',
  mind: 'Mind',
  collaborate: 'Collaborate',
  graph: 'Graph',
}

const ICONS: Record<LensId, string> = {
  home: '🏠',
  reflect: '🪞',
  explore: '🔍',
  judgment: '⚖️',
  finance: '💰',
  health: '❤️',
  mind: '🧠',
  collaborate: '🤝',
  graph: '🕸',
}

const SHORTCUT: Record<LensId, string> = {
  home: '0',
  reflect: '1',
  explore: '2',
  finance: '3',
  health: '4',
  mind: '5',
  collaborate: '6',
  graph: '7',
  judgment: '8',
}

// core / domain / tools の 3 グループ。Judgment は tools グループに合流。
const GROUPS: LensId[][] = [
  ['home', 'reflect', 'explore'],
  ['finance', 'health', 'mind'],
  ['collaborate', 'graph', 'judgment'],
]

export function LensNav() {
  const { lens, navigate } = useV2Router()

  return (
    <>
      {GROUPS.map((group, gi) => (
        <Fragment key={gi}>
          {gi > 0 && <div className="my-1 border-t border-border-subtle" />}
          {group.map((id) => {
            const active = lens === id
            return (
              <button
                key={id}
                type="button"
                onClick={() => navigate(id)}
                title={`${LABELS[id]} (Cmd+${SHORTCUT[id]})`}
                aria-label={LABELS[id]}
                aria-current={active ? 'page' : undefined}
                className={`
                  w-10 h-10 flex items-center justify-center rounded-md
                  text-lg transition
                  ${active
                    ? 'bg-bg-overlay text-text-base'
                    : 'text-text-subtle hover:text-text-base hover:bg-bg-overlay'
                  }
                `}
              >
                <span aria-hidden="true">{ICONS[id]}</span>
              </button>
            )
          })}
        </Fragment>
      ))}
    </>
  )
}
